import { render, staticRenderFns } from "./gift-card.vue?vue&type=template&id=1fc4c17c&scoped=true&"
import script from "./gift-card.vue?vue&type=script&lang=js&"
export * from "./gift-card.vue?vue&type=script&lang=js&"
import style0 from "./gift-card.vue?vue&type=style&index=0&id=1fc4c17c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc4c17c",
  null
  
)

export default component.exports